import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import Draggable from "react-draggable";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getDocsReq } from "../actions/getDocs";
import { IP } from "../config/IP";
import store from "../store/createStore";
import CustomizedInputBase from "./containers/SearchFields";
import TABLE from "./containers/Table";
import DocDetails from "./DocDetails";

function PaperComponent(props) {
	return (
		<Draggable
			handle="#draggable-dialog-title"
			cancel={'[class*="MuiDialogContent-root"]'}
		>
			<Paper {...props} />
		</Draggable>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	useEffect(() => {
		//console.log("TabPanel mounted");
		return () => {
			//console.log("TabPanel unmounted");
		};
	}, [props]);

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`wrapped-tabpanel-${index}`}
			aria-labelledby={`wrapped-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `wrapped-tab-${index}`,
		"aria-controls": `wrapped-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

const DocProcessingScreen = (props) => {
	let { type, docId } = useParams();
	const classes = useStyles();
	const [value, setValue] = React.useState("one");
	const [DocId, setDocId] = React.useState("");
	const dispatch = useDispatch();
	const state = useSelector((state) => state);

	let inputs = {
		url: IP.nodeServer + "api/routesRules",
		method: "POST",
		data: [{ name: "Doc_type_id", value: parseInt(1) }],
	};
	let office_idV = "";
	try {
		office_idV = state.auth.user.office[0].office_id;
	} catch (d) {}
	const [office_id, setOffice_id] = React.useState(office_idV);
	const [firstLoad, setFirstLoad] = React.useState(true);
	const [pageNumber, setPageNumber] = React.useState(0);
	const [pages, setPages] = React.useState(1);
	const [numberRowPerPage, setNumberRowPerPage] = React.useState(5);
	const [totalRow, setTotalRow] = React.useState(20);
	const [open, setOpen] = React.useState(false);
	const [confirmDelete, setConfirmDelete] = React.useState(false);
	const [selectedDoc, setSelectedDoc] = React.useState();

	const [dataloading, setDataloading] = React.useState({
		data: null,
		file: null,
		loading: true,
	});
	//console.log("dataloading=", dataloading);
	let actingOffices = {};
	let assistant_offices=[]
	try {
		actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
			(y) => y.office_id
		);
	} catch (e) {}
	try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}

	const [loadingCond, setLoadingCond] = React.useState(false);

	/*
			docsreq.docs.data.docs
			docsreq.docs.data.file
			docsreq.docs.data.docs
			docsreq.docs.data.limit
			docsreq.docs.data.page
			docsreq.docs.data.total
			docsreq.isDone
			*/

	const handleChange = (event, newValue, newDocId) => {
		//console.log("handleChange=", newValue);
		try {
			if (state.userStatus.isSaved) {
				actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
					(y) => y.office_id
				);
				try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}
			}

			setValue(newValue);
			if (newDocId) {
				//if (newValue === "two") {

				//getDocsById(inputs);
				console.log("DocProcessingScreen newDocId=", newDocId);

				setDocId(newDocId);
				//}
			}
			if (newValue === "one") {
				setOffice_id("");
				//console.log("handleChange 2=", newValue);
				setOffice_id(
					state.auth.user.office ? state.auth.user.office[0].office_id : ""
				);

				setLoadingCond(false);
			} else {
				setOffice_id(
					state.auth.user.office ? state.auth.user.office[0].office_id : ""
				);

				setLoadingCond(true);
			}
		} catch (e) {}
	};
	const handleChangeTablePage = (value) => {
		setDataloading({
			data: null,
			file: null,
			loading: true,
		});
		try {
			console.log("handleChangeTablePage value=", value);
			//setPageNumber(value);
			try {
				actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
					(y) => y.office_id
				);
			} catch (e) {}
			try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}
			inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",

				office_id: office_id,
				companyId: state.companyData.selectedCompanyId,
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,
				page: value + 1,
				limit: numberRowPerPage,
				action: null,
			};
			console.log("handleChangeTablePage clicked inputs=", inputs);
			dispatch(
				getDocsReq({
					url: IP.nodeServer + "api/getDocs",
					method: "POST",

					office_id: office_id,
					companyId: state.companyData.selectedCompanyId,
					actingOffices: actingOffices,
					assistant_offices:assistant_offices,
					page: value + 1,
					limit: numberRowPerPage,
					action: null,
				})
			);

			setFirstLoad(false);
			console.log("handleChangeTablePage Clicked");

			console.log("pageNumber after handleChangeTablePage=", pageNumber);
		} catch (e) {
			console.log("Error handleChangeTablePage e=", e);
		}
	};
	const onChangeTableRowsPerPage = (value) => {
		console.log("onChangeTableRowsPerPage Clicked!");
	};

	/*
	
	*/
	//console.log("state.auth.user.office=", state.auth.user.office);

	//console.log("data in DocProcessingScreen=", dataloading.data);
	/*
	

	
	
	*/
	// before creating Docs Details
	//console.log("DocId before return=", DocId);
	//let details = DocId !== null && <DocDetails DocId={DocId} />;
	let details;

	//console.log("value DocId.DocId=" + DocId.length);
	if (value === "two" && DocId.length > 0) {
		details = DocId !== null && <DocDetails DocId={DocId} />;
	}
	const loadnew = async (typeValue) => {
		setDataloading({
			data: null,
			file: null,
			loading: true,
		});
		try {
			if (state.docsreq.isDone) {
				let currentstate = store.getState();

				let response = currentstate.docsreq.docs;

				if (response.data) {
					console.log("loadnew axios response.data=", response.data);
					let doclist = response.data;
					let docsin = [];
					let respCondition = false;

					let data = [];
					let files = [response.data.file];
					let direction;
					console.log("doclist=", doclist);
					let docs = doclist.docs.filter((x) => x.currentSituation.action >= 0);
					if (typeValue === "trash") {
						docs = doclist.docs.filter((x) => x.currentSituation.action === 0);
					}
					if (typeValue === "draft") {
						docs = doclist.docs.filter((x) => x.currentSituation.action === 1);
					}

					await docs.map((doclist) => {
						try {
							if (doclist.historySituation.length > 0) {
								respCondition = true;
							}
							if (doclist.currentSituation.direction == 1) {
								direction = <ArrowUpwardIcon />;
							} else if (doclist.currentSituation.direction == -1) {
								direction = <ArrowDownwardIcon />;
							} else {
								direction = "";
							}

							data.push({
								DocName: doclist.DocName,
								DocType: doclist.DocType,
								DocTypeDescription: currentstate.loadRoutes.docType.filter(
									(x) => x.Doc_type_id === parseInt(doclist.DocType)
								)[0].name,

								currentOfficeLocation:
									doclist.currentSituation.currentOfficeLocation,

								currentOfficeLocationName: currentstate.auth.user.allOffices.filter(
									(x) =>
										x.office_id ===
										doclist.currentSituation.currentOfficeLocation
								)[0].office_name,
								office_id: doclist.office_id,
								OwnerOfficeLocationName: currentstate.auth.user.allOffices.filter(
									(x) => x.office_id === doclist.office_id
								)[0].office_name,
								CreatorUserId: doclist.CreatorUserId,
								CreatorUserName: currentstate.auth.user.allUser.find(
									(y) => y._id === doclist.CreatorUserId
								).username,
								direction: direction,
								status: doclist.currentSituation.status,
								statusDescription: doclist.currentSituation.statusDescription,
								statusDate: doclist.currentSituation.statusDate,
								action: currentstate.auth.user.settings[0].action.filter(
									(x) => x.id == parseInt(doclist.currentSituation.action)
								)[0].actionDescription,
								actionDate: doclist.currentSituation.actionDate,
								id: doclist._id,
								comments: doclist.comments,
								StepProgress: doclist.StepProgress,
								historySituation: doclist.historySituation,
								deleteDisabled:
									doclist.currentSituation.status <= 3
										? typeValue === "trash"
											? true
											: doclist.currentSituation.action === 0
											? true
											: false
										: true,
							});
						} catch (e) {
							console.log("DocProcessingScreen result catch e=", e);
						}
					});
					docsin = {
						title: "Available Documents",
						columns: [
							{ title: "DocName", field: "DocName" },
							{ title: "DocTypeDescription", field: "DocTypeDescription" },
							{
								title: "OwnerOfficeLocationName",
								field: "OwnerOfficeLocationName",
							},
							{
								title: "CreatorUserName",
								field: "CreatorUserName",
							},

							{
								title: "currentOfficeLocationName",
								field: "currentOfficeLocationName",
							},
							{ title: "direction", field: "direction" },
							{ title: "statusDescription", field: "statusDescription" },
							{ title: "statusDate", field: "statusDate" },
							{ title: "action", field: "action" },
							{ title: "actionDate", field: "actionDate" },
							{ title: "id", field: "id" },
						],
						data: data,
					};
					console.log("docsin=", docsin);

					setDataloading({
						data: docsin,
						files: files,
						loading: false,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
					setPageNumber(response.data.page);
					setPages(response.data.pages);
				}
			}
		} catch (e) {
			setDataloading({
				data: null,
				file: null,
				loading: false,
			});
			console.log("error issue=", e);
		}
	};
	const handleSearch = (e, value) => {
		e.preventDefault();
		setDataloading({
			data: null,
			file: null,
			loading: true,
		});
		console.log("handleSearch=", value);
		inputs = {
			url: IP.nodeServer + "api/getDocs",
			method: "POST",

			office_id: office_id,
			companyId: state.companyData.selectedCompanyId,
			actingOffices: actingOffices,
			assistant_offices:assistant_offices,
			searchKey: value,
			page: 1,
			limit: 100,
			action: null,
		};
		if (value) {
			dispatch(
				getDocsReq({
					url: IP.nodeServer + "api/getDocs",
					method: "POST",
					office_id: office_id,
					companyId: state.companyData.selectedCompanyId,
					actingOffices: actingOffices,
					assistant_offices:assistant_offices,
					searchKey: value,
					page: 1,
					limit: 100,
					action: null,
				})
			);
		} else {
			getDocsReq({
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				office_id: office_id,
				companyId: state.companyData.selectedCompanyId,
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,
				page: 1,
				limit: 100,
				action: null,
			});
		}
		setFirstLoad(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	const handleDeleteDocument = (DocIdInfo) => {
		setSelectedDoc(DocIdInfo);
		setOpen(true);
	};
	useEffect(() => {
		if (confirmDelete) {
			setOpen(false);
			console.log("handleDeleteDocument DocIdInfo=", selectedDoc);
			const token = localStorage.getItem("token");
			const config = {
				headers: {
					"x-auth-token": token,
					"content-type": "application/json",
				},
			};
			let insert = {
				action: "deleteDoc",
				docId: selectedDoc.id,
				office_id: state.auth.user.office
					? state.auth.user.office[0].office_id
					: "",
				companyId: state.companyData.selectedCompanyId,
			};
			console.log("handleDeleteDocument insert=", insert);

			axios
				.post(IP.nodeServer + "api/deleteDoc", insert, config)
				.then((response) => {
					console.log("DocProcessingScreen response=", response);
					try {
						actingOffices = state.userStatus.actingOfficeHierarchy[0].map(
							(y) => y.office_id
						);
					} catch (e) {}
					try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}
					dispatch(
						getDocsReq({
							url: IP.nodeServer + "api/getDocs",
							method: "POST",

							office_id: office_id,
							companyId: state.companyData.selectedCompanyId,
							actingOffices: actingOffices,
							assistant_offices:assistant_offices,
							page: pageNumber + 1,
							limit: numberRowPerPage,
							action: null,
						})
					);
				})
				.catch((error) => {
					console.log("DocProcessingScreen error=", error);
				});
		}
	}, [confirmDelete, setConfirmDelete]);

	useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));

		console.log("useEffect state.docsreq=", state.docsreq);
		if (state.docsreq.isDone) loadnew(type);
	}, [state.docsreq.isLoading]);
	useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (type) {
			console.log("DocProcessingScreen type Effect after type=", type);
			setDataloading({ ...dataloading, loading: true });
			loadnew(type);
		}
	}, [type]);
	useEffect(() => {
		if (state.companyData.isSaved) {
			let actingOffices = {};
			try {
				actingOffices = state.userStatus.status.actingOffice
					.filter((x) => new Date(x.toDate) >= new Date() && !x.cancelled)
					.map((x) => x.officeActingOnBehalf);
				console.log("DashboardScreen real actingOffices=", actingOffices);
			} catch (e) {}

			try{

			assistant_offices=state.officeData.allOffice.filter(
				(x) => x.companyId === state.companyData.selectedCompanyId && x.assistant_offices.map(y=>y.office_id).includes(state.auth.user.office[0].office_id))
			}
			catch(e)
			{}

			inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				office_id: state.auth.user.office
					? state.auth.user.office? state.auth.user.office[0].office_id:""
					: "",
				companyId: state.companyData.selectedCompanyId,
				actingOffices: actingOffices,
				assistant_offices:assistant_offices,
				filterDocId: docId,
				page: 1,
				limit: 5,
				action: null,
			};
			console.log("DocProcessingScreen useEffect  clicked inputs=", inputs);
			dispatch(getDocsReq(inputs));
		}
	}, [state.companyData.isSaved]);

	console.log("DocProcessingScreen useParams()=", useParams());

	return (
		<div className={classes.root}>
			<AppBar position="static">
				<Tabs
					value={value}
					onChange={handleChange}
					//onClick={handleClick}
					aria-label="wrapped label tabs example"
				>
					<Tab
						value="one"
						label="Document List"
						wrapped
						{...a11yProps("one")}
					/>
					<Tab value="two" label="Document Details" {...a11yProps("two")} />
				</Tabs>
			</AppBar>

			<TabPanel value={value} index="one">
				{props.showSearch && (
					<CustomizedInputBase
						placeholder="Search for a Document"
						handleSearch={handleSearch}
					/>
				)}
				{dataloading.loading ? (
					"Loading"
				) : (
					<TABLE
						showSearch={false}
						Inputs={dataloading.data}
						handleChange={handleChange}
						issuer="DocProcessingScreen"
						showActions={true}
						handleChangeTablePage={handleChangeTablePage}
						onChangeTableRowsPerPage={onChangeTableRowsPerPage}
						pageNumber={pageNumber}
						firstLoad={firstLoad}
						numberRowPerPage={numberRowPerPage}
						totalRow={totalRow}
						pages={pages}
						showCustomizedToolbar={true}
						handleDeleteDocument={handleDeleteDocument}
					/>
				)}
			</TabPanel>
			<TabPanel value={value} index="two">
				{dataloading.loading ? "loading" : details}
			</TabPanel>
			<Dialog
				open={open}
				onClose={handleClose}
				PaperComponent={PaperComponent}
				aria-labelledby="draggable-dialog-title"
			>
				<DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
					Delete
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Please Confirm if you want to proceed and delete the document.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={() => setConfirmDelete(true)} color="primary">
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};



const mapStateToProps = (state) => ({
	state,
});

export default connect(mapStateToProps)(DocProcessingScreen);
